import { useEffect } from 'react';
import useSWR from 'swr';
import {axiosApiInstance} from '../services/axios';
import {axiosApiForLogin} from '../services/axiosForLogin';
import { useDispatch } from 'react-redux';

import { updateUser } from '../redux/slices/auth';


const useAuth = (forLogin=false)=>{

    const dispatch = useDispatch()

    const { data, error, mutate, isValidating } = useSWR('user_me' , async()=>{
        return forLogin ? await axiosApiForLogin.get('/admin/profile') : await axiosApiInstance.get('/admin/profile');
    } , {  
        revalidateIfStale: false,  
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        shouldRetryOnError: false
    });

    // Derive loading state: loading when we don't have data and haven't encountered an error yet
    // or when SWR is currently validating
    const loading = isValidating || (!data && !error);

    useEffect(()=>{

        dispatch(updateUser({
            user : data?.data?.data ,
            loading : loading,
            error : error,
        }));

    } , [data, error, loading, dispatch]);


    return {user : data?.data?.data , error, loading, mutate }

}

export default useAuth;